import { render, staticRenderFns } from "./NavigationButton.vue?vue&type=template&id=a0cb4538&scoped=true"
import script from "./NavigationButton.vue?vue&type=script&lang=ts"
export * from "./NavigationButton.vue?vue&type=script&lang=ts"
import style0 from "./NavigationButton.vue?vue&type=style&index=0&id=a0cb4538&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0cb4538",
  null
  
)

export default component.exports